export const roles = {
  super_admin: 'super_admin',
  corporation_admin: 'corporation_admin',
  admin: 'admin',
  recruiter: 'recruiter',
  candidate: 'candidate'
}

export const roleManagers = [roles.super_admin, roles.corporation_admin, roles.admin, roles.recruiter]

export const roleAdmins = [roles.super_admin, roles.corporation_admin, roles.admin]

export const roleCandidates = [roles.candidate]



// WEBPACK FOOTER //
// ./src/settings/roles.js